export enum Section {
  About = 'About',
  Projects = 'Projects',
  Experience = 'Experience',
  Contact = 'Contact',
}
